// Help Center registry — metadata only (small). Article HTML lives in
// content/<slug>.json (one file per article) and is loaded lazily by HelpDetail
// via import.meta.glob so the index stays light. content.json is the combined
// dump the scripts/ generators read and write — not used by the app.
import data from './articles.json';

export const CATEGORIES = data.categories;
export const ARTICLES = data.articles;

const CAT_LABEL = Object.fromEntries(CATEGORIES.map((c) => [c.id, c.label]));

export const categoryLabel = (id) => CAT_LABEL[id] || id;

export const getArticleBySlug = (slug) => ARTICLES.find((a) => a.slug === slug);

export const getArticlesByCategory = () =>
  CATEGORIES.map((c) => ({
    ...c,
    articles: ARTICLES.filter((a) => a.category === c.id),
  })).filter((c) => c.articles.length > 0);

export const getRelated = (slug, limit = 6) => {
  const cur = getArticleBySlug(slug);
  if (!cur) return [];
  return ARTICLES.filter((a) => a.category === cur.category && a.slug !== slug).slice(0, limit);
};

export const searchArticles = (query) => {
  const q = query.trim().toLowerCase();
  if (!q) return [];
  return ARTICLES.filter(
    (a) =>
      a.title.toLowerCase().includes(q) ||
      (a.description && a.description.toLowerCase().includes(q))
  ).slice(0, 12);
};
